<template>
  <pagefra>
    <div class="feedback container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('标题')">
              <el-input
                v-model="form.title"
                :placeholder="$l('标题')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('处理进度')">
              <el-select
                v-model="form.handleStatus"
                :placeholder="$l('处理进度')"
              >
                <el-option :label="$l('处理进度')" value="-1"></el-option>
                <el-option :label="$l('处理中')" value="0"></el-option>
                <el-option :label="$l('已完成')" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              round
              type="primary"
              icon="el-icon-plus"
              @click="showFeedback(1)"
              v-if="hasPermission('反馈')"
              >{{ $l("反馈") }}
            </el-button>
            <el-button
              round
              icon="el-icon-delete"
              @click="deleteFeedback"
              v-if="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('标题')"
              prop="title"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('反馈人')"
              prop="creator"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('反馈时间')"
              prop="feedbackTime"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('处理进度')"
              prop="handleStatus"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-tag
                  type="primary"
                  size="medium"
                  effect="plain"
                  round
                  v-if="scope.row.handleStatus === 0"
                  >{{ $l("处理中") }}
                </el-tag>
                <el-tag
                  type="info"
                  size="medium"
                  effect="plain"
                  round
                  v-if="scope.row.handleStatus === 1"
                  >{{ $l("已完成") }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('处理回复')"
              prop="replyStatus"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-tag
                  type="primary"
                  size="medium"
                  effect="plain"
                  round
                  v-if="scope.row.replyStatus === 0"
                  >{{ $l("未回复") }}
                </el-tag>
                <el-tag
                  type="info"
                  size="medium"
                  effect="plain"
                  round
                  v-if="scope.row.replyStatus === 1"
                  >{{ $l("已回复") }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('回复人')"
              prop="replier"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('回复时间')"
              prop="replyTime"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('评价')"
              min-width="200"
              align="center"
              v-if="hasPermission('评价')"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.replyStatus == 0 ||
                    (!scope.row.rating &&
                      $store.state.user.username != scope.row.creator)
                  "
                  >—</span
                >
                <el-rate
                  v-else
                  v-model="scope.row.rating"
                  :disabled="scope.row.rating > 0"
                  @change="submitEvaluate(scope.row)"
                ></el-rate>
                <!-- <el-rate
                  v-else
                  v-model="rating"
                  @change="submitEvaluate(scope.row)"
                ></el-rate>-->
                <!-- <el-button
                  v-else
                  type="text"
                  icon="el-icon-edit-outline"
                  class="table-icon"
                  @click="openEvaluate(scope.$index, scope.row)"
                ></el-button>-->
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('回复')"
              min-width="150"
              align="center"
              v-if="hasPermission('回复')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.replyStatus == 0 &&
                    $store.state.user.username != scope.row.creator
                  "
                  type="text"
                  icon="el-icon-edit-outline"
                  class="table-icon"
                  @click="showFeedback(2, scope.row)"
                >
                </el-button>
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('详情')"
              min-width="150"
              align="center"
              v-if="hasPermission('详情')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="showFeedback(3, scope.row)"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l(feedbackDialogTitle)"
        :visible.sync="feedbackDialogVisible"
      >
        <el-form
          ref="feedbackForm"
          :model="feedbackForm"
          :rules="feedbackRules"
          label-width="140px"
          size="medium"
          class="feedbackForm"
        >
          <el-form-item :label="$l('反馈人')">
            <el-input
              v-model="feedbackForm.creator"
              :readonly="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('反馈标题')" prop="title">
            <el-input
              v-model="feedbackForm.title"
              :readonly="type != 1"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('反馈时间')" v-if="type != 1">
            <el-input
              v-model="feedbackForm.feedbackTime"
              :readonly="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('反馈内容')" prop="feedbackContent">
            <el-input
              type="textarea"
              :rows="5"
              v-model="feedbackForm.feedbackContent"
              :readonly="type != 1"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('回复人')"
            v-if="type != 1 && feedbackForm.replier"
          >
            <el-input
              v-model="feedbackForm.replier"
              :readonly="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('回复时间')"
            v-if="type == 3 && feedbackForm.replyTime"
          >
            <el-input
              v-model="feedbackForm.replyTime"
              :readonly="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('回复内容')"
            prop="replyContent"
            v-if="type == 2 || (type == 3 && feedbackForm.replyContent)"
          >
            <el-input
              type="textarea"
              :rows="5"
              v-model="feedbackForm.replyContent"
              :readonly="type == 3"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="type != 3">
          <el-button round @click="feedbackDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button round @click="feedbackDialogVisible = false"
            >{{ $l("关闭") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import global from "@/mixins/global.js";
export default {
  name: "feedback",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateTitle = (rule, value, callback) => {
      if (!value || value.trim() == "") {
        callback(new Error(this.$l("请输入标题")));
      } else {
        callback();
      }
    };
    var validateFeedbackContent = (rule, value, callback) => {
      if (!value || value.trim() == "") {
        callback(new Error(this.$l("请输入反馈内容")));
      } else {
        callback();
      }
    };
    var validateReplyContent = (rule, value, callback) => {
      if (!value || value.trim() == "") {
        callback(new Error(this.$l("请输入回复内容")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      form: {
        title: "",
        handleStatus: "-1",
      },
      tableData: [],
      loading: false,
      selectedList: [],
      feedbackForm: {
        feedbackId: "",
        title: "",
        feedbackContent: "",
        creator: "",
        feedbackTime: "",
        replyContent: "",
        replier: "",
        replyTime: "",
      },
      feedbackRules: {
        title: [
          { validator: validateTitle, trigger: "blur" },
          {
            max: 200,
            message: this.$l("长度不能超过 200 个字符"),
            trigger: "blur",
          },
        ],
        feedbackContent: [
          { validator: validateFeedbackContent, trigger: "blur" },
          {
            max: 500,
            message: this.$l("长度不能超过 500 个字符"),
            trigger: "blur",
          },
        ],
        replyContent: [
          { validator: validateReplyContent, trigger: "blur" },
          {
            max: 500,
            message: this.$l("长度不能超过 500 个字符"),
            trigger: "blur",
          },
        ],
      },
      feedbackDialogTitle: "",
      feedbackDialogVisible: false,
      type: 1,
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_feedback_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    viewFeedback(row) {
      row.type = 1;
      this.openNewWindow(JSON.stringify(row));
    },
    // openReply(row) {
    //   row.type = 2;
    //   this.openNewWindow(JSON.stringify(row));
    // },
    showFeedback(type, row) {
      this.type = type;
      this.feedbackDialogVisible = true;
      if (this.$refs.feedbackForm) {
        this.$refs.feedbackForm.clearValidate();
      }
      for (const key in this.feedbackForm) {
        this.feedbackForm[key] = "";
      }
      if (type == 1) {
        this.feedbackDialogTitle = "添加异常反馈";
        this.feedbackForm.creator = this.$store.state.user.username;
      } else {
        for (const key in this.feedbackForm) {
          this.feedbackForm[key] = row[key];
        }
        if (type == 2) {
          this.feedbackForm.replier = this.$store.state.user.username;
          this.feedbackDialogTitle = "回复异常反馈";
        } else {
          this.feedbackDialogTitle = "查看异常反馈";
        }
      }
    },
    submit() {
      this.$refs.feedbackForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_feedback_url, this.feedbackForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.feedbackDialogVisible = false;
                this.initData();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    // showFeedback() {
    //   this.openNewWindow("");
    // },
    // openNewWindow(row) {
    //   let routeUrl = this.$router.resolve({
    //     path: "feedbackEdit"
    //   });
    //   window.open(routeUrl.href + "?row=" + row, "_blank");
    // },
    submitEvaluate(row) {
      this.confirmAlert(
        () => {
          this.$http
            .post(this.$apiConfig.save_feedback_url, row)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        },
        "你确定要提交评价吗？",
        () => {
          row.rating = 0;
        }
      );
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteFeedback() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let feedbackIdList = [];
        for (let i = 0; i < len; i++) {
          feedbackIdList.push(this.selectedList[i].feedbackId);
        }
        let formData = new FormData();
        formData.append("feedbackIdList", feedbackIdList);
        this.$http
          .post(this.$apiConfig.delete_feedback_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(3);
            this.$sentry.captureException(error);
          });
      });
    },
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
};
</script>
<style lang="scss" scoped>
.feedback {
  em {
    color: red;
  }
  .feedbackForm {
    /deep/ .el-textarea__inner {
      border-radius: 1em;
    }
  }
}
</style>
